import { render } from "./Equalizer.vue?vue&type=template&id=2cbb67bc&scoped=true&ts=true"
import script from "./Equalizer.vue?vue&type=script&lang=ts"
export * from "./Equalizer.vue?vue&type=script&lang=ts"

import "./Equalizer.vue?vue&type=style&index=0&id=2cbb67bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbb67bc"]])

export default __exports__